import { Component } from 'react'
import { RouteComponentProps } from 'react-router'
import { LocalstorageKeys } from '../../../types/enums'

class NavigateToUrl extends Component<RouteComponentProps> {
  componentDidMount() {
    const { pathname } = window.location
    const path = sessionStorage.getItem(LocalstorageKeys.savedUrlPath)

    if (pathname === '/index.html' || path === '/index.html') {
      this.clearSavedPath()
      this.props.history.push('/')
      return
    }

    if (path) {
      this.clearSavedPath()
      this.props.history.push(path)
    }
  }

  render() {
    return null
  }

  private clearSavedPath() {
    sessionStorage.removeItem(LocalstorageKeys.savedUrlPath)
  }
}

export default NavigateToUrl
